import { Inject, Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { Observable, map } from 'rxjs';
import { DocumentPropertyCodes } from 'src/app/core/constantes/document-property-codes';
import { SortDirections } from 'src/app/core/constantes/sort-directions';
import { DateHelper } from 'src/app/helpers/date-helper';
import { PropertyType } from 'src/app/models/enums/property-type';
import { ColumnDefinition } from 'src/app/models/server/column-definition';
import { FolderDocument } from 'src/app/models/server/folder-document';
import { DetailBaseDatasource } from '../../../../datasources/detail-base-datasource';

@Injectable()
export class DocumentsDatasource {
    /**
     * Tri par défaut.
     */
    public defaultSort: Sort = { active: DocumentPropertyCodes.CREATION_DATE, direction: SortDirections.DESC };

    constructor(
        private detailDatasource: DetailBaseDatasource,
        @Inject('Window') private window: Window
    ) {}

    /**
     * Retourne la liste des définitions de colonnes du tableau.
     * @returns Une liste de définitions de colonnes.
     */
    public getColumnDefinitions(): ColumnDefinition[] {
        let detailDefinition: ColumnDefinition[] = [];

        if (window.innerWidth > 1280) {
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.CREATION_DATE,
                header: 'Date',
                type: PropertyType.Date,
                displayFormat: DateHelper.FRENCH_DATETIME_FORMAT,
                size: 130,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.TYPE,
                header: 'Type',
                type: PropertyType.Enum,
                displayFormat: null,
                size: 40,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.FLUX,
                header: 'Flux',
                type: PropertyType.Enum,
                displayFormat: null,
                size: 40,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.ATTACHMENTS,
                header: 'PJ',
                type: PropertyType.List,
                displayFormat: null,
                size: 40,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.FROM,
                header: 'De',
                type: PropertyType.Text,
                displayFormat: null,
                size: 170,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.TO,
                header: 'A',
                type: PropertyType.Text,
                displayFormat: null,
                size: 170,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.LABEL,
                header: 'Intitulé',
                type: PropertyType.Text,
                displayFormat: null,
                size: null,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
        } else {
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.ORIGINAL_DATE,
                header: 'Date',
                type: PropertyType.Date,
                displayFormat: DateHelper.FRENCH_DATETIME_FORMAT,
                size: 130,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.FROM,
                header: 'De',
                type: PropertyType.Text,
                displayFormat: null,
                size: 140,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.TO,
                header: 'A',
                type: PropertyType.Text,
                displayFormat: null,
                size: 140,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
            detailDefinition.push({
                propertyCode: DocumentPropertyCodes.LABEL,
                header: 'Intitulé',
                type: PropertyType.Text,
                displayFormat: null,
                size: 140,
                values: null,
                custom: false,
                isStickyColumn: false,
            });
        }

        return detailDefinition;
    }

    /**
     * Liste les données à afficher dans le tableau.
     * @param viewId : Id de la vue.
     * @param folderId : Id du dossier.
     * @returns : Une liste de données à afficher dans le tableau.
     */
    public listDatas(viewId: number, folderId: string): Observable<FolderDocument[]> {
        return this.detailDatasource.listDocuments(viewId, folderId).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
